import {connect} from 'react-redux';
import React from 'react';

import SelectEventScreen from './common/SelectEventScreen';
import Validate from '../../../validate/Validate';

const ConnectedScreenComponent = connect((state, props) => {
    return {
        i18n: state.i18n.translations,
        events: state.events.loadedEvents.map(id => state.events[id].event).filter(event => event._isCommunity),
    };
})(SelectEventScreen);

export default props => (
    <Validate
        validate={state => {
            if (!state.events.loadedEvents.map(id => state.events[id].event).filter(event => event._isCommunity).length) {
                throw new Error('No communities to delete');
            }
        }}>
        <ConnectedScreenComponent {...props.match.params} />
    </Validate>
);
